import { AuthService, setupBackendAuthService, setupDemoAuthService } from '@/services/AuthService.js'
import { DataService, setupBackendDataService, setupDemoDataService } from '@/services/DataService.js'
import router from '@/router'

export const namespaced = true
const tokenKey = 'AUTH_SID'

function setupBackendServices () {
  setupBackendAuthService()
  setupBackendDataService()
}

function setupDemoServices () {
  setupDemoAuthService()
  setupDemoDataService()
}

export const state = {
  user: null
}

export const getters = {
  loggedIn (state) {
    return !!state.user
  },
  tokenKey () {
    return tokenKey
  },
  user (state) {
    return state.user
  }
}

export const mutations = {
  SET_USER_TOKEN (state, data) {
    localStorage.setItem(tokenKey, data.token)
  },
  SET_USER_DATA (state, data) {
    state.user = data
  },
  CLEAR_USER_DATA () {
    localStorage.removeItem(tokenKey)
  }
}

export const actions = {
  async autoLogin ({ commit, dispatch, getter, rootGetters }) {
    var token = getTokenFromLocalStorage()
    if (token === 'DEMO_TOKEN') {
      // Заходим под демо-пользователем
      setupDemoServices()
      return Promise.resolve({})
    } else {
      setupBackendServices()
      // Если смогли получить SID из адресной строки браузера,
      // то считаем его приоритетным и заменям им предыдущий SID
      var newToken = fetchSidFromWindow()
      if (newToken) {
        token = newToken
      }

      // Если SID обнаружили, то кладём токен в хранилище
      if (token) {
        setTokenToLocalStorage(token)
        // Пытаемся с помощью токена подтянуть инфу о пользователе
        const { data: { userInfo } } = await AuthService.userInfo(token)
        if (userInfo) {
          // Пользователь залогинен
          return setupLoggedInUser({ commit, dispatch }, userInfo, token)
        }
      }

      // Не удалось залогиниться
      return Promise.resolve({})
    }
  },
  async login ({ commit, dispatch, getter, rootGetters }, credentials) {
    setupBackendServices()
    const { login, password } = credentials
    return AuthService.authenticate(login, password)
      .then((user) => {
        return setupLoggedInUser({ commit, dispatch }, user, user.sid)
          .then(() => {
            return router.push(rootGetters['settings/menu/firstTopLevelItem'].route)
          })
      })
  },
  async demoLogin ({ commit, dispatch, getter, rootGetters }) {
    setupDemoServices()
    return AuthService.authenticate()
      .then((user) => {
        return setupLoggedInUser({ commit, dispatch }, user, 'DEMO_SID')
          .then(() => {
            return router.push(rootGetters['settings/menu/firstTopLevelItem'].route)
          })
      })
  },
  logout ({ commit }) {
    commit('CLEAR_USER_DATA')
    AuthService.logout().finally(() => {
      location.replace('/')
    })
  },
  userInfo ({ commit }) {
    return AuthService.userInfo(data => commit('SET_USER_DATA', data)).then(data => commit('SET_USER_DATA', data)).catch(console.err)
  }
}

async function setupLoggedInUser ({ commit, dispatch }, userInfo, sid) {
  setTokenToLocalStorage(sid)
  commit('SET_USER_DATA', userInfo)
  return DataService.initialLoad(dispatch)
    .then(() => {
      dispatch('settings/load', null, { root: true })
    })
}

function setTokenToLocalStorage (data) {
  localStorage.setItem(tokenKey, data)
}

function getTokenFromLocalStorage () {
  return localStorage.getItem(tokenKey)
}

function fetchSidFromWindow () {
  const sid = parseInt(new URL(window.location.href).searchParams.get('sid'))
  if (isNaN(sid)) {
    return undefined
  } else {
    return sid
  }
}
